module.exports = __webpack_public_path__ + "static/media/216-Uebergabe_ID_4.7e048fbe.mp3";